import SelectStore from '@components/select-store/SelectStore';
import { RoutePaths } from '@enums/RoutePaths';
import { useCheckDevice } from '@hooks/UseCheckDevice';
import { completeAuthentication, getParsedToken } from '@services/auth/AuthService';
import { ErrorToast } from '@services/utils/ToastUtils';
import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

export type HomePageProps = {
  openedFromModal: boolean;
  closeModal?: () => void;
};

const HomePage: FC<HomePageProps> = ({ openedFromModal, closeModal }) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { isMobileDevice, isTabletDevice } = useCheckDevice();

  useEffect(() => {
    if (location.state && location.state?.name == 'default') {
      completeAuthentication().then(
        (token) => {
          if (token) {
            const currentUser = getParsedToken();
            const doNotShowInvitation = localStorage.getItem('doNotShowInvitationPage');
            if (
              !checkIfPWA() &&
              (isMobileDevice || isTabletDevice) &&
              doNotShowInvitation !== 'true'
            ) {
              navigation(RoutePaths.Invitation);
            }

            if (checkIfPWA() && !currentUser.isPrimaryUser) {
              navigation(RoutePaths.PWA);
              return;
            }
          }
        },
        (err) => {
          ErrorToast('Something went wrong: ' + err);
        },
      );
    }
  }, []);

  const checkIfPWA = () => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      return true;
    }
    return false;
  };
  return <SelectStore openedFromModal={openedFromModal} closeModal={closeModal} />;
};

export default HomePage;
